export const getParsedDQScore = (score: string): string => {
  const stringifyScore = `${score}`;

  return stringifyScore &&
    stringifyScore !== "null" &&
    stringifyScore !== "undefined"
    ? `${Math.round(Number.parseFloat(stringifyScore || "0"))}`
    : "";
};
